import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box, ThemeProvider as ThemeProviderV5 } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { theme } from './theme';
import createStore from './store';
import Header from './components/Header/Header';
import Main from './Main';
import ErrorBoundary from './components/ErrorBoundary';
import { Spinner } from './components/Spinner';
import { EnvironmentIdentifier } from './components/EnvironmentIdentifier';
import { Authenticate } from './Authenticate';
import { VersionChecker } from './components/VersionChecker';
import { Provider as AdminProvider } from './sections/admin/context.jsx';

export const store = createStore();

export default function App() {
  return (
    <IntlProvider locale={navigator.language}>
      <ThemeProviderV5 theme={theme}>
        <ErrorBoundary>
          <Suspense fallback={<Spinner />}>
            <Provider store={store}>
              <AdminProvider>
                <Router>
                  <EnvironmentIdentifier
                    className="app"
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <VersionChecker>
                      <Header />
                      <Box sx={{ flex: 1, overflow: 'hidden' }}>
                        <Authenticate>
                          {({ user }) => <Main user={user} />}
                        </Authenticate>
                      </Box>
                    </VersionChecker>
                  </EnvironmentIdentifier>
                </Router>
              </AdminProvider>
            </Provider>
          </Suspense>
        </ErrorBoundary>
      </ThemeProviderV5>
    </IntlProvider>
  );
}
